type MonitorIdHashList = string[][];

export const MonitorSetting: MonitorIdHashList = [
    ["1","579","DWEdNq32","1892","1034","1"],
    ["2","580","M4mL1b3R","1269","2013","2"],
    ["3","581","24Erlq3D","1193","2126","1"],
    ["4","582","NxmRp9jD","1550","1869","1"],
    ["5","583","yp3VXBE8","1479","2295","1"],
    ["6","584","Rd3MAJ3p","1366","2579","2"],
    ["7","585","nVmoVVEl","420","1814","2"],
    ["8","586","D0mZAnEM","477","1829","4"],
    ["9","587","6R3bqlmr","370","1800","5b"],
    ["10","588","673QO1EV","315","1865","5b"],
    ["11","589","MbmOe5jQ","312","1901","6"],
    ["12","590","bVjp0Vjl","162","2146","5b"],
    ["13","591","7g3291mB","131","2263","5b"],
    ["14","592","463Y1Y38","168","2275","1"],
    ["15","593","4Q38pe3w","467","1787","5b"],
    ["16","594","vWjXylEe","564","1948","5b"],
    ["17","595","do3n7yjW","565","2161","5b"],
    ["18","596","OQ3yoREW","651","2342","7"],
    ["19","597","gbj1L53d","545","2240","5b"],
    ["20","598","ovEA65mB","512","2576","8"],
    ["21","599","M236Qvmy","379","2548","5b"],
    ["22","600","673QO8EV","331","2601","5b"],
    ["23","601","MbmOeNjQ","399","2670","9"],
    ["24","602","bVjp0gjl","0","0","0"],

];
